module.exports = __webpack_public_path__ + "img/icon_piccola_white.c198cb18.png";